import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "xl:w-1/2 justify-start flex-col" }

import { useStore } from 'vuex';
import StaffLineTuning from './StaffLineTuning.vue';
import RezTabFile from '@/store/modules/RezTabFile';
import { StaffLine } from '@/store/modules/Staff';
import TuningPresetSelector from './TuningPreset/TuningPresetSelector.vue';
import { TTabCourseTuningInfo, TTuningPreset } from '@/store/modules/db-types';
import { ref } from 'vue';
import { TabCourseTuningInfo } from '@/store/modules/types';
import TabTypeToggler from './TabTypeToggler.vue';
import { useDoc } from '@/composables/useDoc';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
function getSection() { return (store.state.currentDoc as RezTabFile).section }
const updateKey = ref(Math.random());
function updateLines() {


    updateKey.value = Math.random();
        setTimeout(() => {
        useDoc().updateUI()
    }, 500);

}
function addStaffLine(tuningPreset?: TTabCourseTuningInfo) {

    const doc = store.state.currentDoc as RezTabFile;
    doc.section.addLineToStaff(tuningPreset, 0);
    updateLines()
    // setTimeout(() => {
    //     doc.updateUI()
    // }, 500);

}


function removeStaffLine(staffIndex: number, lineN: number) {
    (store.state.currentDoc as RezTabFile).section.removeLineFromStaff(staffIndex, lineN)
    // store.state.currentDoc.unfreeze()
    updateLines()

}

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TabTypeToggler),
    _createVNode(TuningPresetSelector, {
      staffIndex: 0,
      onAddStaffLine: addStaffLine,
      onRemoveStaffLine: removeStaffLine
    }),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.currentDoc.section.measures[0].staves[0].lines, (staffLine, index) => {
        return (_openBlock(), _createBlock(StaffLineTuning, {
          key: (index as number) + updateKey.value,
          staffIndex: 0,
          tuning: getSection().info.staves[0].tuning?.find(l => l.n == (staffLine as StaffLine).courseInfo.number),
          staffLineN: (staffLine as StaffLine).courseInfo.number,
          onRemoveStaffLine: removeStaffLine
        }, null, 8, ["tuning", "staffLineN"]))
      }), 128)),
      _createVNode(_component_va_button, {
        disabled: _unref(store).state.currentDoc.section.measures[0].staves[0].lines.length >= 14,
        class: "bg-sky-950 w-32 h-12 mt-3 rounded-xl text-white shadow-lg bg-gradient-to-t py-2 text-6xl",
        type: "button",
        onClick: addStaffLine
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("+", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})